import { AbstractIconComponent } from './abstract.icon'
import { Component, Input } from '@angular/core'
import { ColorPipe } from '../pipes/color.pipe'

@Component({
  selector: 'icon-position',
  templateUrl: './position.icon.html',
  imports: [ColorPipe],
})
export class PositionIconComponent extends AbstractIconComponent {
  @Input() hasDeniedGpsAccess = false
  static icon = 'position'
}
